export default "__VITE_ASSET__DXwbOVl6__"